// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Partner central account management (PARTNERCENTRAL-ACCOUNT-MANAGEMENT)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspartnercentralaccountmanagement.html
 *
 * 2025-02-24T21:49:09.425Z
 */
export enum AwsPartnercentralAccountManagementActions {
  /**
   * Grants permission to associate Partner account to AWS account
   *
   * See https://docs.aws.amazon.com/partner-central/latest/getting-started/controlling-access-in-apc-account-management.html
   */
  AssociatePartnerAccount = 'partnercentral-account-management:AssociatePartnerAccount',
  /**
   * Grants permission to associate Partner user to IAM role
   *
   * See https://docs.aws.amazon.com/partner-central/latest/getting-started/controlling-access-in-apc-account-management.html
   */
  AssociatePartnerUser = 'partnercentral-account-management:AssociatePartnerUser',
  /**
   * Grants permission to disassociate Partner user to IAM role
   *
   * See https://docs.aws.amazon.com/partner-central/latest/getting-started/controlling-access-in-apc-account-management.html
   */
  DisassociatePartnerUser = 'partnercentral-account-management:DisassociatePartnerUser',
}
